/* eslint-disable */
import { get } from "@bigyouth/base";

import { FORM_ACTIONS } from "./formValidation";
import { ACTIONS as MODAL_ACTIONS } from "./modal";

import { get as getPipe } from "../utils/sigpipe";

/**
 * This is a mock form component using 'js-form-validation' field checking.
 * 'js-form-validation' generate a pipe and set a unique 'data-form-id' on the element it's added.
 * The pipe can be fetched with this id, and will receive the events emitted by 'js-form-validation'.
 */
export default {
  name: "form-submit",

  componentDidMount() {
    setTimeout(() => {
      const formId = this.el.getAttribute("data-form-id");
      if (formId) {
        this.pipe = getPipe(formId);

        if (this.pipe) {
          this.pipe.on(({ action, formData }) => {
            let dataForm = new FormData();

            for (var key in formData) {
              dataForm.append(key, formData[key]);
            }

            switch (action) {
              case FORM_ACTIONS.SUBMIT:
                console.info(
                  `form ${this.pipe.id} has been submitted with these values:`,
                  formData
                );

                /* AJAX PROCESS

                var XHR = new XMLHttpRequest()
                XHR.addEventListener('load', event => {
                  let resp = JSON.parse(event.target.responseText)

                  console.log(resp)

                  if (resp.errors) {

                  } else {
                    const modal = get("#form-modal");
                    const pipe = getPipe(modal.getAttribute("data-pipe-id"));
                    pipe.write({ action: MODAL_ACTIONS.OPEN });

                  }
                })

                XHR.addEventListener('error', event => {
                  console.log("Oups! Quelque chose s'est mal passé.")
                })


                let formAction = this.el.action ? this.el.action : '/recruitment-form/submit'
                
                console.log('formAction', formAction)
                XHR.open('POST', formAction)

                XHR.send(dataForm)
                */
                // this.el.submit();

                grecaptcha.ready(() => {
                  grecaptcha
                    .execute("6LcPYHcfAAAAAMGm0Lh0qjLjB4Oswl_wY5fNPthY", {
                      action: "submit"
                    })
                    .then(token => {
                      console.log(
                        token,
                        document.querySelector('input[type="hidden"]')
                      );

                      document.querySelector(
                        'input[type="hidden"]'
                      ).value = token;
                      // console.log(token);
                      // populatee hidden input then submit
                      // Add your logic to submit to your backend server here.
                      this.el.submit();
                    });
                });

                break;

              case FORM_ACTIONS.ERROR:
                console.warn(
                  `form ${this.pipe.id} contains errors in these values:`,
                  dataForm
                );
                break;
            }
          });
        }
      }
    }, 300);
  }
};
/* eslint-enable */
